module.exports = __webpack_public_path__ + "static/velourteddymain-c6e20128278f326977acdc2c7474691b.jpeg";